import constants from 'common/constants'

import {BULK_DELETE_ENTITIES} from './ActionTypes/ApiActionTypes'

/**
 * Unified bulk delete/inactivate for selective AI master-data pages.
 * @param {string} entity - teachers | students | grades | sections | classes | subjects
 * @param {number[]} ids
 */
export const bulkDeleteEntities = (entity, ids, onSuccess, onFailure) => {
  return {
    type: BULK_DELETE_ENTITIES,
    payload: {
      apiUrl: constants.api_bulk_delete,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      body: {entity, ids},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/** Deletes all onboarding sample data in one request. */
export const deleteSampleData = (onSuccess, onFailure) => {
  return {
    type: BULK_DELETE_ENTITIES,
    payload: {
      apiUrl: constants.api_bulk_delete,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      body: {entity: 'sample_data'},
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
